<template>
	<div class="pride-main">
    <a class="skip-to-content-link" href="#main">
      Skip to content
    </a> 
		<navigation />
		  <main id="main">
        <pride-hero />
        <pride-c-t-a-bar :ctaBar="PrideBodyData.CTA_BAR"/>
        <pride-chosen-families :chosenFamilies="PrideBodyData.CHOSEN_FAMILIES"/>
        <pride-coming-home :comingHome="PrideBodyData.COMING_HOME"/>
        <pride-safe-spaces :safeSpaces="PrideBodyData.SAFE_SPACES"/>
        <pride-places-container :places="PrideBodyData.PLACES"/>
        <pride-stonewall-inn :stonewall="PrideBodyData.STONE_WALL"/>
      </main>
		<bubly-footer />
	</div>
</template>


<script>

  import Navigation from '@/components/Navigation';
  import PrideHero from '@/components/pride/PrideHero';
  import PrideChosenFamilies from '@/components/pride/PrideChosenFamilies';
  import PrideComingHome from '@/components/pride/PrideComingHome';
  import PrideSafeSpaces from '@/components/pride/PrideSafeSpaces';
  import PrideStonewallInn from '@/components/pride/PrideStonewallInn';
  import PrideCTABar from '@/components/pride/PrideCTABar';
  import PridePlacesContainer from '@/components/pride/PridePlacesContainer';
  import BublyFooter from '@/components/BublyFooter';
  import Social from '@/components/common/Social';
  import PrideBodyData from "./../../static/libs/pride-body";

  export default {
    name: 'pride',
    components: {
      Navigation,
      PrideHero,
      PrideCTABar,
      PrideChosenFamilies,
      PrideComingHome,
      PrideSafeSpaces,
      PridePlacesContainer,
      PrideStonewallInn,
      BublyFooter,
      Social,
    },
    // mounted() {
    //   this.changeBG();
    // },
    // methods: {

    //   changeBG(){   

    //     let container = document.querySelector('.pride-people-container');
    //     let colors = ['#ec1c24', '#ed2f25', '#fae72b', '#dadf2d','#16b036','#3e62b0', '#6d459b']

    //     window.addEventListener('scroll', function () {
    //       if (document.documentElement.scrollTop || window.pageYOffset > window.innerHeight) {
    //         // var diff = parseInt(window.pageYOffset - window.innerHeight);
    //         var startPoint = parseInt(window.pageYOffset - container.offsetTop);
    //         var step = parseInt(container.offsetHeight/9);
    //         container.style.backgroundColor = colors[Math.floor(startPoint/step)];
    //       }
    //     })
    //   }
    // },
    data() {
      return {
        PrideBodyData,
      };
    },
  };

</script>

<style lang="scss">

.pride-main {
  h1, h2, h3, p {
    margin: 0;
  }

  h1 {
    font-size: 15vw;
    margin: 0 0 0.5em 0;

    @media (max-width: 768px) {
      line-height: 16vw;
    }

    @media (min-width: 600px) {
      font-size: 60px;
      line-height: 65px;
    }

    @media (min-width: 768px) {
      font-size: 60px;
    }
  }
  
  h2 {
    font-size: 36px;
    margin: 0 0 1.5em 0;
  }

  h3 {
    font-size: 28px;
    line-height: 35px;
  }

  p {
    font-size: 20px;
    line-height: 30px;
  }

  .pride-btn {
    border-radius: 22.5px;
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    background-color: #fff;
    border: 0;
    font-size: 28px;
    font-weight: 600;
    color: #009fdf;
    padding: .10em 1em;
    margin: 1.5em 0 0 0;
    cursor: pointer;
  }

  .section {
    padding: 0 1.5em;
    overflow: hidden;

    @media (min-width: 768px) {
      padding: 0 4em;
      display: flex;
      align-items: center;
    }

    .pride-inner {
      margin: 0 auto;
      
      @media (min-width: 768px) {
        max-width: 1200px;
      } 

      @media (min-width: 1920px) {
        max-width: 1500px;
      } 
    }
  }
  }

  /*hacky hack.  tagline in footer appears when <p> font-size greater than 0. this sets it back to 0*/
  .social-content p {
    font-size: 0;
  }


</style>




// WEBPACK FOOTER //
// src/pages/Pride.vue